var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"position":"absolute","left":"0px"},attrs:{"width":_vm.imageWidth,"height":_vm.imageHeight},on:{"click":function($event){_vm.doMove=!_vm.doMove}}})])}
var staticRenderFns = []

export { render, staticRenderFns }